
function MsgPanelCtrl(TranslationService) {
    var ctrl = this;

    this.close = function () {
        ctrl.msg = null;
    }
}

MsgPanelCtrl.$inject = ['TranslationService'];

seedWebApp.component('msgPanel', {
    controller: MsgPanelCtrl,
    bindings: {
        msg: '=',
    },
    templateUrl: '/SPA/Orders/msgPanel.html' + seedWebApp.buildVersion
});